import {vantUiPlugin} from '@/plugin/vant-ui';


export function initPlugin(Vue) {

  vantUiPlugin(Vue)
}
